import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/auth",
      name: "auth",
      component: () => import("../views/auth/index.vue"),
      meta: { title: "微信授权" }
    },
    {
      path: "/home",
      name: "home",
      component: () => import("../views/home/index.vue"),
      meta: { title: "首页" }
    },
    {
      path: "/dzp",
      name: "dzp",
      component: () => import("../views/activity/dzp.vue"),
      meta: { title: "东丽祝你马到成功" }
    },
    {
      path: "/dzp1",
      name: "dzp1",
      component: () => import("../views/activity/dzp1.vue"),
      meta: { title: "调查问卷活动抽奖" }
    },
    {
      path: "/sign",
      name: "sign",
      component: () => import("../views/activity/sign.vue"),
      meta: { title: " 2023上马名额等你来拼" }
    },
    {
      path: "/luck_grid",
      name: "luck_grid",
      component: () => import("../views/activity/luck_grid.vue"),
      meta: { title: "申爱相拥" }
    },
    {
      path: "/h5",
      name: "h5",
      component: () => import("../views/activity/h5.vue"),
      meta: { title: "" }
    },
    {
      path: "/template",
      name: "template",
      component: () => import("../views/activity/template.vue"),
      meta: { title: "你的“申”爱海报定制通道" }
    },
    {
      path: "/bullet_chat",
      name: "bullet_chat",
      component: () => import("../views/activity/bullet_chat.vue"),
      meta: { title: "申爱无界" }
    },
    {
      path: "/form123",
      name: "form123",
      component: () => import("../views/activity/form.vue"),
      meta: { title: "东丽进博会" }
    },
    {
      path: "/follow",
      name: "follow",
      component: () => import("../views/activity/follow.vue"),
      meta: { title: "关注东丽中国" }
    },
    {
      path: "/bullet_screen_wall",
      name: "bullet_screen_wall",
      component: () => import("../views/activity/bullet_screen_wall.vue"),
      meta: { title: "弹幕墙" }
    },
    {
      path: "/bullet_screen_wall1",
      name: "bullet_screen_wall1",
      component: () => import("../views/activity/bullet_screen_wall1.vue"),
      meta: { title: "弹幕墙" }
    },
    {
      path: "/obtain",
      name: "obtain",
      component: () => import("../views/activity/obtain.vue"),
      meta: { title: "2024东丽材料部门展会" }
    },
    {
      path: "/form",
      name: "form",
      component: () => import("../views/activity/material_exhibition.vue"),
      meta: { title: "CHFE2025" }
    },
    {
      path: "/scratch_card",
      name: "scratch_card",
      component: () => import("../views/activity/scratch_card.vue"),
      meta: { title: "刮刮卡" }
    },
    {
      path: "/photograph-Expo",
      name: "photograph-Expo",
      component: () => import("../views/activity/photograph-Expo.vue"),
      meta: { title: "2024东丽进博会拍照打卡" }
    },
    {
      path: "/shake",
      name: "shake",
      component: () => import("../views/activity/shake.vue"),
      meta: { title: "上马上上签" }
    },
    {
      path: "/answer",
      name: "answer",
      component: () => import("../views/activity/answer.vue"),
      meta: { title: "答题" }
    },
    {
      path: "/flip_game",
      name: "flip_game",
      component: () => import("../views/activity/flip_game.vue"),
      meta: { title: "东了个东" }
    },
    {
      path: "/my_card",
      name: "my_card",
      component: () => import("../views/activity/my_card.vue"),
      meta: { title: "我的签包" }
    },
    {
      path: "/guide_page",
      name: "guide_page",
      component: () => import("../views/activity/guide_page.vue"),
      meta: { title: "2024第七届进博会-东丽展位" }
    },
    {
      path: "/page1",
      name: "page1",
      component: () => import("../views/guide/page1.vue"),
      meta: { title: "商品1" }
    },
    {
      path: "/page2",
      name: "page2",
      component: () => import("../views/guide/page2.vue"),
      meta: { title: "商品2" }
    },
    {
      path: "/page3",
      name: "page3",
      component: () => import("../views/guide/page3.vue"),
      meta: { title: "商品3" }
    },
    {
      path: "/information",
      name: "information",
      component: () => import("../views/guide/information.vue"),
      meta: { title: "个人信息" }
    },
    {
      path: "/product-m1",
      name: "product-m1",
      component: () => import("../views/guide/product-m1.vue"),
      meta: { title: "产品1" }
    },
    {
      path: "/product-m2",
      name: "product-m2",
      component: () => import("../views/guide/product-m2.vue"),
      meta: { title: "产品2" }
    },
    {
      path: "/product-m3",
      name: "product-m3",
      component: () => import("../views/guide/product-m3.vue"),
      meta: { title: "产品3" }
    },
    {
      path: "/product-m4",
      name: "product-m4",
      component: () => import("../views/guide/product-m4.vue"),
      meta: { title: "产品4" }
    },
    {
      path: "/product-m5",
      name: "product-m5",
      component: () => import("../views/guide/product-m5.vue"),
      meta: { title: "产品5" }
    },
    {
      path: "/product-m6",
      name: "product-m6",
      component: () => import("../views/guide/product-m6.vue"),
      meta: { title: "产品6" }
    },
    {
      path: "/product-m7",
      name: "product-m7",
      component: () => import("../views/guide/product-m7.vue"),
      meta: { title: "产品7" }
    },
    {
      path: "/product-m8",
      name: "product-m8",
      component: () => import("../views/guide/product-m8.vue"),
      meta: { title: "产品8" }
    },
    {
      path: "/product-m3-2",
      name: "product-m3-2",
      component: () => import("../views/guide/product-m3-2.vue"),
      meta: { title: "m3-2" }
    },
    {
      path: "/product-m5-2",
      name: "product-m5-2",
      component: () => import("../views/guide/product-m5-2.vue"),
      meta: { title: "m5-2" }
    },
    {
      path: "/form2024",
      name: "form2024",
      component: () => import("../views/expo/form2024.vue"),
      meta: { title: "东丽进口博览会" }
    },
    {
      path: "/product-m9-11",
      name: "product-m9-11",
      component: () => import("../views/guide/product-m9-11.vue"),
      meta: { title: "m9-11" }
    },
    {
      path: "/product-m12-14",
      name: "product-m12-14",
      component: () => import("../views/guide/product-m12-14.vue"),
      meta: { title: "m12-14" }
    },
    {
      path: "/product-L1",
      name: "product-L1",
      component: () => import("../views/guide/product-L1.vue"),
      meta: { title: "L1" }
    },
    {
      path: "/product-L2",
      name: "product-L2",
      component: () => import("../views/guide/product-L2.vue"),
      meta: { title: "L2" }
    },
    {
      path: "/product-L3",
      name: "product-L3",
      component: () => import("../views/guide/product-L3.vue"),
      meta: { title: "L3" }
    },
    {
      path: "/product-L4",
      name: "product-L4",
      component: () => import("../views/guide/product-L4.vue"),
      meta: { title: "L4" }
    },
    {
      path: "/product-L5",
      name: "product-L5",
      component: () => import("../views/guide/product-L5.vue"),
      meta: { title: "L5" }
    },
    {
      path: "/product-L6",
      name: "product-L6",
      component: () => import("../views/guide/product-L6.vue"),
      meta: { title: "L6" }
    },
    {
      path: "/product-L7",
      name: "product-L7",
      component: () => import("../views/guide/product-L7.vue"),
      meta: { title: "L7" }
    },
    {
      path: "/product-L8-5",
      name: "product-L8-5",
      component: () => import("../views/guide/product-L8-5.vue"),
      meta: { title: "L8-5" }
    },
    ,
    {
      path: "/product-L9",
      name: "product-L9",
      component: () => import("../views/guide/product-L9.vue"),
      meta: { title: "L9" }
    },
    {
      path: "/product-L9-2",
      name: "product-L9-2",
      component: () => import("../views/guide/product-L9-2.vue"),
      meta: { title: "L9-2" }
    },
    {
      path: "/product-L9-3",
      name: "product-L9-3",
      component: () => import("../views/guide/product-L9-3.vue"),
      meta: { title: "L9-3" }
    },
    {
      path: "/product-L9-4",
      name: "product-L9-4",
      component: () => import("../views/guide/product-L9-4.vue"),
      meta: { title: "L9-4" }
    },
    {
      path: "/product-H1",
      name: "product-H1",
      component: () => import("../views/guide/product-H1.vue"),
      meta: { title: "H1" }
    },
    {
      path: "/product-H2",
      name: "product-H2",
      component: () => import("../views/guide/product-H2.vue"),
      meta: { title: "H2" }
    },
    {
      path: "/product-H3",
      name: "product-H3",
      component: () => import("../views/guide/product-H3.vue"),
      meta: { title: "H3" }
    },
    {
      path: "/product-H4",
      name: "product-H4",
      component: () => import("../views/guide/product-H4.vue"),
      meta: { title: "H4" }
    },
    {
      path: "/product-H5",
      name: "product-H5",
      component: () => import("../views/guide/product-H5.vue"),
      meta: { title: "H5" }
    },
    {
      path: "/product-H6",
      name: "product-H6",
      component: () => import("../views/guide/product-H6.vue"),
      meta: { title: "H6" }
    },
    {
      path: "/product-H7",
      name: "product-H7",
      component: () => import("../views/guide/product-H7.vue"),
      meta: { title: "H7" }
    },
    {
      path: "/product-H8",
      name: "product-H8",
      component: () => import("../views/guide/product-H8.vue"),
      meta: { title: "H8" }
    },
    {
      path: "/product-H9",
      name: "product-H9",
      component: () => import("../views/guide/product-H9.vue"),
      meta: { title: "H9" }
    },
    {
      path: "/product-H10",
      name: "product-H10",
      component: () => import("../views/guide/product-H10.vue"),
      meta: { title: "H10" }
    },
    {
      path: "/form2024info",
      name: "form2024info",
      component: () => import("../views/expo/form2024info.vue"),
      meta: { title: "进博会-2024留资" }
    },
    {
      path: "/classify-page1",
      name: "classify-page1",
      component: () => import("../views/guide/classify-page1.vue"),
      meta: { title: "" }
    },
    {
      path: "/classify-page2",
      name: "classify-page2",
      component: () => import("../views/guide/classify-page2.vue"),
      meta: { title: "" }
    },
    {
      path: "/classify-page3",
      name: "classify-page3",
      component: () => import("../views/guide/classify-page3.vue"),
      meta: { title: "" }
    },
    {
      path: "/classify-page4",
      name: "classify-page4",
      component: () => import("../views/guide/classify-page4.vue"),
      meta: { title: "" }
    },
    {
      path: "/product-N1",
      name: "product-N1",
      component: () => import("../views/guide/product-N1.vue"),
      meta: { title: "" }
    },
    {
      path: "/product-N2",
      name: "product-N2",
      component: () => import("../views/guide/product-N2.vue"),
      meta: { title: "" }
    },
    {
      path: "/product-N3",
      name: "product-N3",
      component: () => import("../views/guide/product-N3.vue"),
      meta: { title: "" }
    },
    {
      path: "/product-N4",
      name: "product-N4",
      component: () => import("../views/guide/product-N4.vue"),
      meta: { title: "" }
    },
    {
      path: "/write_off",
      name: "write_off",
      component: () => import("../views/activity/write_off.vue"),
      meta: { title: "卡券核销" }
    },
    {
      path: "/2048",
      name: "2048",
      component: () => import("../views/activity/2048.vue"),
      meta: { title: "活动页面" }
    },
    {
      path: "/2048test",
      name: "2048test",
      component: () => import("../views/activity/2048test.vue"),
      meta: { title: "2048test" }
    },
    {
      path: "/infinite_game",
      name: "infinite_game",
      component: () => import("../views/activity/2025/infinite_game.vue"),
      meta: { title: "无限游戏" }
    },
    {
      path: "/christmasGame",
      name: "christmasGame",
      component: () => import("../views/activity/2025/christmasGame.vue"),
      meta: { title: "挑战无限“东”力，赢取圣诞好礼" }
    },
    {
      path: "/SHmarathon2025",
      name: "SHmarathon2025",
      component: () => import("../views/activity/2025/index.vue"),
      meta: { title: "活动页面" }
    },
    {
      path: "/challenge",
      name: "challenge",
      component: () => import("../views/activity/2025/challenge.vue"),
      meta: { title: "马拉松每日挑战" }
    },
    {
      path: "/Expo2025",
      name: "Expo2025",
      component: () => import("../views/expo/2025/index.vue"),
      meta: { title: "东丽展台场景" }
    },
    {
      path: "/scene",
      name: "scene",
      component: () => import("../views/expo/2025/scene.vue"),
      meta: { title: "东丽展台场景" }
    },
    {
      path: "/claimprize",
      name: "claimprize",
      component: () => import("../views/activity/2025/claimprize.vue"),
      meta: { title: "申爱无界" }
    },
    {
      path: "/prizePC",
      name: "prizePC",
      component: () => import("../views/activity/2025/prizePC.vue"),
      meta: { title: "PC后台扫码兑换奖品" }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js